import { Database02Icon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import { Button } from '@/design-system';

import { BaseProps } from './ExampleCrudPane';
import { KVOnlyExampleCrudPane } from './KVOnlyExampleCrudPane';

export const ExampleCrudPaneWithButton = ({
  run,
  example,
  dataset,
  onSuccess,
  disabled,
  color,
  omitIcon,
  trigger,
  ...props
}: BaseProps & { disabled?: boolean }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonColor = color ?? 'secondary';
  const label = example ? 'Edit' : run ? 'Add to Dataset' : 'Add Example';

  const ExamplePaneComponent = KVOnlyExampleCrudPane;

  const handleClick = () => setIsOpen(true);

  return (
    <>
      {trigger ? (
        trigger(handleClick)
      ) : (
        <Button
          size="md"
          variant="outlined"
          onClick={handleClick}
          color={buttonColor}
          leftDecorator={!omitIcon && Database02Icon}
          {...props}
          disabled={disabled}
        >
          {label}
        </Button>
      )}
      {/* in the run details pane, we use a fallback if the run hasn't loaded yet - this fallback is taken from the 
           runs table, which doesn't load full inputs/outputs. If we render the exampleCrudPane before we have an 
           input (which all runs have, but won't be present in the fallback), then we end up just showing null inputs/outputs.
           However, if there is no run or example then we are just creating a new example, in which case we should always render the pane. */}
      {(example?.inputs || run?.inputs || (!example && !run)) && (
        <ExamplePaneComponent
          key={example?.id ?? run?.id}
          run={run}
          example={example}
          dataset={dataset}
          isOpen={isOpen}
          doClose={() => setIsOpen(false)}
          onSuccess={onSuccess}
        />
      )}
    </>
  );
};
